import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
  GoodsReceipt, GoodsReceiptCreateDTO, GoodsReceiptResponse
} from '../interfaces/procurement/goodsReceipt.interface';

export const GoodsReceiptService = {
  listByInstitution: async (page = 0, size = 10): Promise<GoodsReceiptResponse> => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    return (await axios.get(`${ENDPOINTS.GOODS_RECEIPT.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data;
  },
  getById: async (id: string): Promise<GoodsReceipt> =>
    (await axios.get(ENDPOINTS.GOODS_RECEIPT.GET_BY_ID(id))).data,
  create: async (dto: GoodsReceiptCreateDTO): Promise<GoodsReceipt> =>
    (await axios.post(ENDPOINTS.GOODS_RECEIPT.CREATE, dto)).data,
  post: async (id: string): Promise<GoodsReceipt> =>
    (await axios.post(ENDPOINTS.GOODS_RECEIPT.POST(id))).data,
  reverse: async (id: string): Promise<GoodsReceipt> =>
    (await axios.post(ENDPOINTS.GOODS_RECEIPT.REVERSE(id))).data,
};
